export interface TimeSlotRange {
  id: string;
  startTime: string;
  endTime: string;
}

export interface ClosureRange {
  time_slot_id: string;
  start_date: string;
  end_date: string;
}

export function doTimeSlotsOverlap(a: TimeSlotRange, b: TimeSlotRange): boolean {
  return a.startTime < b.endTime && a.endTime > b.startTime;
}

export function getOverlappingSlotIds(
  selectedSlot: TimeSlotRange,
  timeSlots: TimeSlotRange[],
): string[] {
  return timeSlots
    .filter(slot => slot.id === selectedSlot.id || doTimeSlotsOverlap(slot, selectedSlot))
    .map(slot => slot.id);
}

export function filterSlotsWithoutClosure(
  timeSlotIds: string[],
  closures: ClosureRange[],
  startDate: string,
  endDate: string,
): string[] {
  return timeSlotIds.filter(timeSlotId => !closures.some(closure =>
    closure.time_slot_id === timeSlotId &&
    startDate <= closure.end_date &&
    endDate >= closure.start_date
  ));
}

export function isDateCoveredByClosure(date: string, closures: ClosureRange[]): boolean {
  return closures.some(closure => date >= closure.start_date && date <= closure.end_date);
}